var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGarden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.1 398.5",
    style: {
      enableBackground: "new 0 0 490.1 398.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#848484;}\n\t.st1{fill:#514F97;}\n\t.st2{fill:#972679;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.4,99.8v-7.1h226.1v7.1c0,3.9-3,7.1-6.6,7.1H140C136.3,106.9,133.4,103.7,133.4,99.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.3,7.1c0-3.9-3-7.1-6.6-7.1h-66.5c-3.6,0-6.6,3.2-6.6,7.1v7.1h79.8L286.3,7.1L286.3,7.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.5,149.6h-9.1c-3.6,0-6.7,3.2-6.7,7.1c0,1.9,0.7,3.6,1.9,5c1.2,1.4,2.9,2.2,4.7,2.2h10.1L142.5,149.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.5,71.3c0-3.9-3-7.1-6.6-7.1H140c-3.6,0-6.6,3.2-6.6,7.1v7.1h226.1L359.5,71.3L359.5,71.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.6,313.5c-3.6,0-6.6,3.2-6.6,7.1v42.8c0,3.9,2.9,7.1,6.6,7.1h11l-3.9-57L146.6,313.5L146.6,313.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330,33c-1-2.7-3.5-4.5-6.2-4.5H169c-2.7,0-5.1,1.8-6.2,4.5l-6.3,16.8h179.8L330,33z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.5,149.6L359.5,149.6h-9.1l-1,14.3h10c1.7,0,3.4-0.7,4.6-2.1c1.3-1.3,2-3.1,2-5.1 C366.1,152.8,363.1,149.6,359.5,149.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.1,313.5h-7l-3.9,57h11c3.6,0,6.6-3.2,6.6-7.1v-42.8C352.8,316.7,349.8,313.5,346.1,313.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.4,320.6h-32c-3.1,0-5.8,2.3-6.5,5.5L208.2,399h76.4l-15.7-72.9C268.2,322.9,265.5,320.6,262.4,320.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222.5,202.3c-10.9,11.3-12.3,29.5-3.4,42.6c6.9-9.5,15.1-17.9,24.3-24.9c3.1-2.2,7.2-1.3,9.2,1.9 s1.2,7.6-1.8,9.9c-8.1,6.3-15.4,13.9-21.6,22.4c3.8,2.2,8,3.4,12.3,3.5c7.7,0.2,15.3-2.9,20.9-8.6c16.9-17.2,22-46.7,23.4-74.9 c-10,9.1-22.4,14.6-35.5,16C240.1,191.1,230.4,195.2,222.5,202.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.8,118.8l1.4,20.9l1.9,28.5l9.1,132.8c0.5,1,0.7,2,0.7,3.1c0,0.7-0.1,1.3-0.4,1.9l4.9,70.7 c0.7,11.2,9.4,20,19.9,20h3.1l16.5-76c2-9.8,10.1-16.6,19.4-16.6h32c9.3,0,17.3,6.9,19.4,16.6l16.4,76h3.1 c10.5-0.1,19.1-8.7,19.9-20l4.9-70.7c-0.2-0.6-0.3-1.3-0.4-1.9c0-1.1,0.2-2.1,0.7-3.1l11.2-160.7v-0.1v-0.1l1.4-21.3L153.8,118.8 L153.8,118.8z M271.7,259.5c-7.9,8-18.3,12.5-29.2,12.5c-0.5,0-0.9,0-1.4,0c-6.8-0.2-13.4-2.2-19.2-5.8c-3.3,6.3-5.7,13-7,20.1 c-0.6,3.4-3.4,5.8-6.5,5.8c-0.4,0-0.9,0-1.3-0.1c-1.7-0.4-3.2-1.5-4.2-3c-1-1.6-1.4-3.5-1-5.4c1.8-9.3,5-18.2,9.5-26.4 c-15.9-18.8-15-47.7,2-65.3c9.8-8.9,21.9-14.5,34.7-15.7c15.3-3,28.5-5.6,39-27.6c1.4-3,4.5-4.4,7.5-3.7c3,0.8,5.1,3.6,5.1,6.9 C299.8,190.8,296.6,234,271.7,259.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarden);
export default __webpack_public_path__ + "static/media/garden.eab1674c59929b3e39cb997b55e6e3d2.svg";
export { ForwardRef as ReactComponent };